'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatHeadingConfigPropType = require('../chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _getAnyCompanyLogo = require('conversations-schema/chat-heading-config/operators/getAnyCompanyLogo');

var _getAnyCustomChatName = require('conversations-schema/chat-heading-config/operators/getAnyCustomChatName');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _CompanyAvatar = require('./CompanyAvatar');

var _CompanyAvatar2 = _interopRequireDefault(_CompanyAvatar);

var _AutomatedMessageAvatars = require('./AutomatedMessageAvatars');

var _AutomatedMessageAvatars2 = _interopRequireDefault(_AutomatedMessageAvatars);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InitialMessageAvatar = function (_Component) {
  _inherits(InitialMessageAvatar, _Component);

  function InitialMessageAvatar() {
    _classCallCheck(this, InitialMessageAvatar);

    return _possibleConstructorReturn(this, (InitialMessageAvatar.__proto__ || Object.getPrototypeOf(InitialMessageAvatar)).apply(this, arguments));
  }

  _createClass(InitialMessageAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          chatHeadingConfig = _props.chatHeadingConfig,
          sendFromResponders = _props.sendFromResponders,
          message = _props.message,
          isLastInGroup = _props.isLastInGroup,
          tooltipPlacement = _props.tooltipPlacement,
          responder = _props.responder,
          potentialResponders = _props.potentialResponders;

      var isBot = (0, _responderGetters.getIsBot)(responder);
      var responders = (0, _responderGetters.getIsBot)(responder) ? (0, _immutable.List)([responder]) : sendFromResponders;
      if (!responders.size && (0, _getAnyCompanyLogo.getAnyCompanyLogo)(chatHeadingConfig)) {
        return _react2.default.createElement(_CompanyAvatar2.default, {
          src: (0, _getAnyCompanyLogo.getAnyCompanyLogo)(chatHeadingConfig),
          isLastInGroup: !isBot,
          tooltipPlacement: tooltipPlacement,
          name: (0, _getAnyCustomChatName.getAnyCustomChatName)(chatHeadingConfig)
        });
      }

      var respondersToPass = responders.size ? responders : potentialResponders;

      return _react2.default.createElement(_AutomatedMessageAvatars2.default, {
        responders: respondersToPass,
        message: message,
        isLastInGroup: isLastInGroup
      });
    }
  }]);

  return InitialMessageAvatar;
}(_react.Component);

InitialMessageAvatar.propTypes = {
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  isLastInGroup: _react.PropTypes.bool,
  message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
  potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
  responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
  sendFromResponders: _react.PropTypes.instanceOf(_immutable.List),
  tooltipPlacement: _react.PropTypes.string
};

InitialMessageAvatar.defaultProps = {
  sendFromResponders: (0, _immutable.List)()
};

exports.default = InitialMessageAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/InitialMessageAvatar.js
// module id = 1142
// module chunks = 2 3